import { ProductImportActions } from 'constants/ActionsTypesTs'
import {
	IConfirmImportProductsAction,
	IConfirmImportProductsActionError,
	IConfirmImportProductsActionSuccess,
	IConfirmImportProductsParams,
	IConfirmImportProductsResponse,
	ImportProductError,
	ImportProductsAction,
	ImportProductsActionError,
	ImportProductsParams,
	ImportProductsResponse,
	ImportProductsSuccessAction,
	IPaginationImportProductTableAction,
	IPaginationImportProductTableActionSuccess,
	IPaginationImportProductTableParams,
	IPaginationImportProductTableResponse
} from 'models/ProductImport'

export const importProducts = (
	payload: ImportProductsParams
): ImportProductsAction => ({
	type: ProductImportActions.IMPORT_PRODUCTS,
	payload
})

export const importProductsSuccess = (
	payload: ImportProductsResponse
): ImportProductsSuccessAction => ({
	type: ProductImportActions.IMPORT_PRODUCTS_SUCCESS,
	payload
})

export const clearImportProduct = () => ({
	type: ProductImportActions.CLEAR_IMPORT_PRODUCTS
})

export const importProductsError = (
	payload: ImportProductError
): ImportProductsActionError => ({
	type: ProductImportActions.IMPORT_PRODUCTS_ERROR,
	payload
})

export const confirmImportProducts = (
	payload: IConfirmImportProductsParams
): IConfirmImportProductsAction => ({
	payload,
	type: ProductImportActions.CONFIRM_IMPORT_PRODUCTS
})

export const confirmImportProductsSuccess = (
	payload: IConfirmImportProductsResponse
): IConfirmImportProductsActionSuccess => ({
	payload,
	type: ProductImportActions.CONFIRM_IMPORT_PRODUCTS_SUCCESS
})

export const confirmImportProductsError = (
	payload: ImportProductError
): IConfirmImportProductsActionError => ({
	payload,
	type: ProductImportActions.CONFIRM_IMPORT_PRODUCTS_ERROR
})

export const importProductsPagination = (
	payload: IPaginationImportProductTableParams
): IPaginationImportProductTableAction => ({
	payload,
	type: ProductImportActions.IMPORT_PRODUCTS_TABLE_PAGINATION
})

export const importProductsPaginationSuccess = (
	payload: IPaginationImportProductTableResponse
): IPaginationImportProductTableActionSuccess => ({
	payload,
	type: ProductImportActions.IMPORT_PRODUCTS_TABLE_PAGINATION_SUCCESS
})
